export const OrderByEnum = {
  ASC: 'ascending',
  DESC: 'descending'
}



// WEBPACK FOOTER //
// ./src/constants/orderby.constants.js